import { useState, useEffect } from 'react';
import { API_URL } from '../../config';
import { useAuth } from '../../context/AuthContext';

export default function CostSettings() {
  const { token } = useAuth();
  const [configForm, setConfigForm] = useState({ COST_PER_MATRIX_UNIT: 1 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchConfig();
  }, []);

  const fetchConfig = async () => {
    try {
      const res = await fetch(`${API_URL}/admin/config`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      setConfigForm({
        ...data,
        COST_PER_MATRIX_UNIT: data.COST_PER_MATRIX_UNIT || 1
      });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await fetch(`${API_URL}/admin/config`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(configForm)
      });
      alert('系统配置已更新');
    } catch (err) {
      alert('更新失败');
    }
  };

  if (loading) return <div className="p-8 text-center text-gray-500">加载中...</div>;

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-6">系统扣费设置</h1>
      
      <form onSubmit={handleSubmit}>
      <div className="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-gray-100 dark:border-slate-700/50 overflow-hidden mb-6">
        <div className="p-5 border-b border-gray-100 dark:border-slate-700/50 bg-gray-50/50 dark:bg-slate-900/20">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-slate-100">大模型生成系统 (智墨) / GEO 监控单价配置</h2>
          <p className="text-sm text-gray-500 dark:text-slate-400 mt-1">设置大模型生成任务或大模型搜索结果分析的基础扣费单位。</p>
        </div>
        <div className="p-5 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-2">生成任务 / GEO单次调用基础积分扣除</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                step="0.1"
                value={configForm.COST_PER_MATRIX_UNIT || 0}
                onChange={(e) => setConfigForm({ ...configForm, COST_PER_MATRIX_UNIT: Number(e.target.value) })}
                className="w-48 px-3 py-2 bg-white dark:bg-slate-900 border border-gray-300 dark:border-slate-600 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 text-gray-900 dark:text-slate-100"
              />
              <span className="ml-3 text-sm text-gray-500 dark:text-slate-400">积分 / 每次调用或单篇内容</span>
            </div>
            <p className="mt-2 text-xs text-gray-500 dark:text-slate-500">
              *GEO实际扣费计算公式: 关键词包数量 × 受众人设数量 × 引擎数量 × 基础积分。
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-gray-100 dark:border-slate-700/50 overflow-hidden mb-6">
        <div className="p-5 border-b border-gray-100 dark:border-slate-700/50 bg-gray-50/50 dark:bg-slate-900/20">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-slate-100">SEO 平台抓取单价配置 (RPA通道)</h2>
          <p className="text-sm text-gray-500 dark:text-slate-400 mt-1">SEO 抓取依赖高匿纯净 IP 和 RPA 集群算力，请根据各个平台反爬难度独立设置扣费单价。</p>
        </div>
        <div className="p-5 grid grid-cols-1 md:grid-cols-2 gap-6">
          {[
            { id: 'COST_SEO_XIAOHONGSHU', label: '小红书 (最高防爬)', default: 5 },
            { id: 'COST_SEO_DOUYIN', label: '抖音', default: 4 },
            { id: 'COST_SEO_WECHAT', label: '微信搜一搜', default: 3 },
            { id: 'COST_SEO_ZHIHU', label: '知乎', default: 2 },
            { id: 'COST_SEO_BAIDU', label: '百度搜索', default: 1 },
            { id: 'COST_SEO_BILIBILI', label: 'Bilibili', default: 2 },
          ].map(platform => (
            <div key={platform.id}>
              <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-2">{platform.label}</label>
              <div className="flex items-center">
                <input
                  type="number"
                  min="0"
                  step="0.1"
                  value={configForm[platform.id] !== undefined ? configForm[platform.id] : platform.default}
                  onChange={(e) => setConfigForm({ ...configForm, [platform.id]: Number(e.target.value) })}
                  className="w-32 px-3 py-2 bg-white dark:bg-slate-900 border border-gray-300 dark:border-slate-600 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 text-gray-900 dark:text-slate-100"
                />
                <span className="ml-3 text-sm text-gray-500 dark:text-slate-400">积分 / 词</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <div className="flex justify-end">
        <button
          type="submit"
          className="px-6 py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-medium transition-colors shadow-sm"
        >
          保存扣费配置
        </button>
      </div>
    </form>
    </div>
  );
}
